import { SeatDetail } from '@/src/types/itinerary'
import { useTranslations } from 'next-intl'
import SeatItem from './seatItem'

const SeatItemWrapper = ({
    seat,
    selectedSeatOptions,
    rowCharacteristics,
    handleAddSeat,
    handleRemoveSeat,
    getSeatColor,
    formatCurrency
}: {
    seat: SeatDetail | undefined
    selectedSeatOptions: Partial<SeatDetail>[]
    rowCharacteristics: string
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    getSeatColor: (price: number) => string
    formatCurrency: (price: number) => string
}) => {
    const t = useTranslations('itineraryPage.addons')
    return (
        <SeatItem
            seat={seat}
            selectedSeatOptions={selectedSeatOptions}
            rowCharacteristics={rowCharacteristics}
            handleAddSeat={handleAddSeat}
            handleRemoveSeat={handleRemoveSeat}
            getSeatColor={getSeatColor}
            formatCurrency={formatCurrency}
            t={t}
        />
    )
}

export default SeatItemWrapper
